export default __webpack_public_path__ + "static/media/8.9d1ddd2c.jpg";